import type { Dispatch } from "@reduxjs/toolkit";
import { applyPaycallCallTaken } from "../slices/callCenter.slice";
import { mapPaycallCallTakenPayload } from "./mapPaycallPayloads";

/** SignalR PaycallCallTaken — normalize payload and update call-center state. */
export function handlePaycallCallTaken(
  dispatch: Dispatch,
  payload: unknown
): void {
  const { paycallSoftphone } =
    require("./paycallSoftphone.service") as typeof import("./paycallSoftphone.service");

  const mapped = mapPaycallCallTakenPayload(
    payload,
    paycallSoftphone.getMyExtension()
  );
  if (!mapped) return;

  // Inconclusive "taken" (no agent id / extension not ready) — keep ringing UI;
  // App.setCallActive runs after the therapist answers locally.
  if (!mapped.answeredByMe && !mapped.hasAnsweredAgent) {
    return;
  }

  dispatch(
    applyPaycallCallTaken({
      callId: mapped.callId,
      answeredByMe: mapped.answeredByMe,
    })
  );
}
